/** Logo / brand helpers for learning tutorial editor + flow. */

export function resolveLogoPreviewUrl(url, backendUrl = '') {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url;
  if (url.startsWith('/')) return `${backendUrl}${url}`;
  return `${backendUrl}/${url}`;
}

export function logoModeFromEditor(logo) {
  if (!logo || typeof logo !== 'object') return 'none';
  if (logo.mode) return logo.mode;
  if (logo.text && logo.url) return 'both';
  if (logo.url) return 'image';
  if (logo.text) return 'text';
  return 'none';
}

export function buildEditorLogo({ mode, text, url }) {
  const m = (mode || 'none').trim();
  if (m === 'none') return {};
  const out = { mode: m };
  if (m === 'text' || m === 'both') {
    const t = String(text || '').trim();
    if (t) out.text = t;
  }
  if (m === 'image' || m === 'both') {
    const u = String(url || '').trim();
    if (u) out.url = u;
  }
  if (!out.text && !out.url) return {};
  out.opacity = out.opacity ?? 0.85;
  out.x = out.x ?? 0.92;
  out.y = out.y ?? 0.06;
  return out;
}
